import { axios } from '@complispace/cs-design-system';
import sessionManager from '@/store/modules/session/sessionManager';

const supportSiteUrl = `${process.env.CONTENT_ENGINE_URL}/app/support-site`;
const SUPPORT_SITE_TIMEOUT_MS = 5000;

let supportMode = false;

// Asked with this host's own address, never the target, so a stored target can't change the answer.
// Any failure leaves support mode off. Only loaded when a target is requested or stored, so it means
// "support host acting on a target", not just "support host".
export async function loadSupportMode() {
  try {
    const { data } = await axios.get(supportSiteUrl, {
      headers: { 'x-site-uri': sessionManager.getOwnSiteUrl() },
      timeout: SUPPORT_SITE_TIMEOUT_MS
    });
    supportMode = data?.isSupportSite === true;
  } catch {
    supportMode = false;
  }
}

export function isSupportMode() {
  return supportMode;
}

// Existence is not checked here: ce-app-api rejects an unknown x-site-uri.
export function validateTargetSite(raw) {
  if (typeof raw !== 'string') return null;
  const host = raw.trim().toLowerCase();
  try {
    return host && new URL(`https://${host}`).host === host ? host : null;
  } catch {
    return null;
  }
}
